<div
	class="fixed z-menu backdrop-blur-m inset-0 bg-[rgba(255,255,255,.6)] flex justify-center items-center overflow-y-auto"
>
	<beyond-online-loading-spinner />
</div>
